export const COMMON_FEATURE_FLAGS = ({
  ENABLE_RELATIONSHIPS: 'relationships'
} as const);